// extracted by mini-css-extract-plugin
export default {"root":"AttachmentCarouselArrow_root__rdU0R","prev":"AttachmentCarouselArrow_prev__c4UzZ","next":"AttachmentCarouselArrow_next__UD+fq"};